import $ from 'jquery';

export default class ScrollHandler {
  constructor() {
    this.EVENTS = {
      scroll: 'scrollHandlerScroll'
    };
    this.CLASSES={
      down:'body--scroll-down',
      up:'body--scroll-up',
      top:'body--scroll-top'
    }
    this.TIMEOUT_TIME = 100;
    this.GAP = 50;
    this.lastScrollTop = -1;
    this.DELTA = 5;
    this.didScroll = false;
    this.scrollDown = false;
    this.scrollTop = null;
    this.$body = null;
    this.interval = null;
  }

  init() {
    this.$body = $('body');
    this.killed = false;

    $(window).on('scroll', (e) => {
      $(window).trigger(this.EVENTS.scroll);
    });
  }


  onScroll(callback) {
    $(window).on(this.EVENTS.scroll, () => {
      this.didScroll = true;
    });

    this.interval = setInterval(() => {
      if (this.didScroll) {
        this.hasScrolled();
        this.didScroll = false;
        if (callback) {
          callback(this.scrollDown, this.scrollTop);
        }
      }
    }, this.TIMEOUT_TIME);

    if (callback) {
      this.hasScrolled();
      callback(this.scrollDown, this.scrollTop);
    }
  }

  hasScrolled() {
    this.scrollTop = $(window).scrollTop();
    const headerH = $('.header').height();

    if (this.lastScrollTop>0 && Math.abs(this.lastScrollTop - this.scrollTop) <= this.DELTA) {
      return;
    }

    this.cleanClasses();
    if(this.scrollTop === 0 || this.scrollTop < 50) {
      this.scrollDown = false;
      this.$body.addClass(this.CLASSES.top);
    }else if (this.didScroll && this.scrollTop >= this.lastScrollTop && this.scrollTop > headerH) {
      // Scroll Down
      this.scrollDown = true;
      this.$body.addClass(this.CLASSES.down);
      //use GAP to prevent immediate scroll up down
    } else if (this.scrollTop < this.lastScrollTop - this.GAP) {
      // Scroll Up
      this.scrollDown = false;
      this.$body.addClass(this.CLASSES.up);
    } else{
      this.scrollDown = false;
    }
    this.lastScrollTop = this.scrollTop;
  }

  cleanClasses(){
    this.$body.removeClass(this.CLASSES.down).removeClass(this.CLASSES.up).removeClass(this.CLASSES.top);
  }

  kill() {
    clearInterval(this.interval);
    $(window).off(this.EVENTS.scroll);
    this.killed = true;
    this.didScroll = false;
    this.scrollDown = false;
  }

}